import request from '../utils/request'

export interface DetailLicense {
  customer: string
  distributor: string
  hawaNode: boolean
  hawaServer: boolean
  id: string
  validity: string
}

export interface License {
  clientId: string
  customerName: string
  expire: string
  hostName: string
  licenseId: string
  latitude: number
  longitude: number
  detailLicense: DetailLicense
}

export function ping() {
  return request({
    url: '/ping',
  })
}

export function getLicense(): Promise<License> {
  return request.get('/ping/machine')
}
